import React from 'react';
// Components
import SvgIcon from '../icons/SvgIcon';
// Resources
import { paths } from '../../navigation/routes/paths';
import { stringsRes } from '../../resources/strings';
import configs from '../../config/index';
import { IconAxel, IconCommon } from '../../resources/images';

export interface MenuInfos {
    label: string;
    href: string;
    icon: JSX.Element;
    badgeValue?: number;
    description?: string;
    isPro?: boolean;
}
export interface NavigationHeaderInfos {
    label?: string;
    icon?: JSX.Element;
    href?: string;
    menuItems?: MenuItemDatas[];
    backgroundColor?: 'blue';
}

export interface MenuItemDatas extends MenuInfos {
    onClick?: () => void;
}

interface MenuProps {
    isPro?: boolean;
    totalReservations?: number;
    isAdmin?: boolean;
}

interface MenuAdminProps {
    isAdmin?: boolean;
}

// interface MenuAdminProps {}

const menuBuilder = (props: MenuProps): MenuInfos[] => {
    const { totalReservations } = props;
    const menuContent: MenuInfos[] = [
        // {
        //     label: stringsRes.drawerMenu.home,
        //     href: paths.home,
        //     icon: <SvgIcon icon={IconCommon.Home} size="mediumSmall" stroke="currentColor" />,
        // },
        {
            label: stringsRes.drawerMenu.profil,
            href: paths.profile,
            icon: <SvgIcon icon={IconCommon.UserOutline} size="mediumSmall" stroke="currentColor" />,
        },
        {
            label: stringsRes.drawerMenu.reservations,
            href: paths.reservations,
            icon: (
                <SvgIcon icon={IconAxel.CalendarClock} size="mediumSmall" stroke="currentColor" overwritePathStroke />
            ),
            badgeValue: totalReservations,
        },
        {
            label: stringsRes.drawerMenu.tripHistory,
            href: paths.tripHistory,
            icon: <SvgIcon icon={IconCommon.ClockOutline} size="mediumSmall" stroke="none" fill="currentColor" />,
        },
        {
            label: stringsRes.drawerMenu.favoritesPlaces,
            href: paths.favorites,
            icon: <SvgIcon icon={IconCommon.StarsOutline} size="mediumSmall" stroke="currentColor" />,
        },
        {
            label: stringsRes.drawerMenu.family,
            href: paths.family,
            icon: <SvgIcon icon={IconAxel.UserContact} size="mediumSmall" stroke="currentColor" overwritePathStroke />,
            // description: stringsRes.drawerMenu.onlyForPerso,
        },
        {
            label: stringsRes.drawerMenu.payment,
            href: paths.payment,
            icon: <SvgIcon icon={IconAxel.Card} size="mediumSmall" stroke="currentColor" overwritePathStroke />,
        },
        {
            label: stringsRes.drawerMenu.promoCode,
            href: paths.promo,
            icon: <SvgIcon icon={IconAxel.TicketPromo} size="mediumSmall" stroke="currentColor" overwritePathStroke />,
        },
        {
            label: stringsRes.drawerMenu.support,
            href: paths.support,
            icon: <SvgIcon icon={IconAxel.Help} size="mediumSmall" stroke="currentColor" overwritePathStroke />,
        },
    ];

    if (configs.envConfig.currentEnv.isStaging) {
        const devMenu: MenuInfos[] = [
            {
                label: stringsRes.header.id,
                href: paths.hb,
                icon: <SvgIcon icon={IconCommon.InformationOutline} size="mediumSmall" stroke="currentColor" />,
            },
            // {
            //     label: 'Debug WV',
            //     href: paths.debug,
            //     icon: <SvgIcon icon={IconCommon.InformationOutline} size="mediumSmall" stroke="currentColor" />,
            // },
        ];
        menuContent.push(...devMenu);
    }
    return menuContent;
};

const menuAdminBuilder = (props: MenuAdminProps): MenuInfos[] => {
    const { isAdmin } = props;
    const menuContent: MenuInfos[] = [
        {
            label: stringsRes.adminMenu.groups,
            href: paths.adminGroups,
            icon: (
                <SvgIcon
                    icon={IconCommon.PageListing}
                    size="mediumSmall"
                    stroke="none"
                    fill={isAdmin ? 'white' : 'currentColor'}
                />
            ),
        },
        {
            label: stringsRes.adminMenu.collaborators,
            href: paths.adminUsers,
            icon: <SvgIcon icon={IconCommon.UserOutlineMultiple} size="mediumSmall" stroke="currentColor" />,
        },
        {
            label: stringsRes.drawerMenu.payment,
            href: paths.adminPayment,
            icon: (
                <SvgIcon
                    icon={IconCommon.CardOutline}
                    size="mediumSmall"
                    stroke="none"
                    fill={isAdmin ? 'white' : 'currentColor'}
                />
            ),
        },
        {
            label: stringsRes.adminMenu.billing,
            href: paths.adminBilling,
            icon: <SvgIcon icon={IconCommon.Document} size="mediumSmall" stroke="currentColor" fill="transparent" />,
        },
        // {
        //     label: stringsRes.adminMenu.params,
        //     href: paths.params,
        //     icon: <SvgIcon icon={IconCommon.Gear} size="mediumSmall" stroke="none" fill={isAdmin ? 'white' : 'currentColor'} />,
        // },
    ];
    return menuContent;
};

export default { menuBuilder, menuAdminBuilder };
